import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetOcrAccountsRequestModel, GetOcrAccountsResponseModel } from "@/features/accounts/ocr/services/get-accounts-model";

export class GetOcrAccountsApi {
  /**
   * OCR一覧取得API
   */
  public getOcrAccounts = async (
    param: GetOcrAccountsRequestModel
  ): Promise<GetOcrAccountsResponseModel[]> => {
    const path = `/api/ocraccounts`;
    const res = await ApiClient.instance.get<GetOcrAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
